/*
  EcomHub Pro - carousel engine for Dawn's own sliders.

  This is a PORT of assets/ehp-tst-carousel.js, the engine already used by the
  theme's own carousels, rather than a fresh implementation. Same track moved
  with `transform` and a CSS transition, same clone-set loop, same rotate
  arithmetic. Earlier attempts here animated the native scroll position from
  JavaScript and later did the infinite loop by rotating real cards behind a
  timer - both stuttered, and the timer left a visible pause between cards.

  What makes the loop smooth is that the snap-back happens BEFORE the move, not
  after it: a full clone set follows the originals, so when the track has
  travelled one loop width it is jumped back by exactly that distance with the
  transition off. The content either side of that jump is identical, so nothing
  is visible, and the movement that follows is a single uninterrupted
  transition. There is no timer waiting on an animation to finish.

  Dawn's SliderComponent is deliberately switched off for these sections: their
  arrows no longer carry name="next"/name="previous", so its constructor bails
  on the first guard.
*/
(function () {
  function init(root) {
    if (root.__ehpDawn) return;
    var list = root.querySelector('.slider');
    if (!list) return;

    var slides = [].filter.call(list.children, function (el) {
      return el.nodeType === 1 && el.classList.contains('grid__item');
    });
    if (!slides.length) return;

    root.__ehpDawn = true;

    var prevBtn = root.querySelector('[data-ehp-prev]');
    var nextBtn = root.querySelector('[data-ehp-next]');
    var dotsWrap = root.querySelector('[data-ehp-dots]');
    var curEl = root.querySelector('[data-ehp-current]');
    var totEl = root.querySelector('[data-ehp-total]');

    var autoplay = root.getAttribute('data-ehp-autoplay') === '1';
    var speed = (parseFloat(root.getAttribute('data-ehp-speed')) || 4) * 1000;
    var infinite = root.getAttribute('data-ehp-loop') === 'infinite';
    var autoDir = root.getAttribute('data-ehp-dir') === 'left' ? -1 : 1;

    /* the viewport clips; the list becomes the track */
    var vp = document.createElement('div');
    vp.className = 'ehp-dawn-vp';
    list.parentNode.insertBefore(vp, list);
    vp.appendChild(list);

    var index = 0, pos = 0, dotIdx = 0, cloned = false, timer = null, rt = null;

    /* ---- state ----------------------------------------------------------- */
    function isStatic() {
      var w = window.innerWidth;
      if (list.classList.contains('slider--everywhere')) return false;
      if (list.classList.contains('slider--desktop') && w >= 990) return false;
      if (list.classList.contains('slider--tablet') && w <= 989) return false;
      if (list.classList.contains('slider--mobile') && w <= 749) return false;
      return true;
    }
    function gap() {
      var cs = getComputedStyle(list);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }
    function slideStep() {
      if (slides.length > 1) {
        var d = slides[1].offsetLeft - slides[0].offsetLeft;
        if (d > 0) return d;
      }
      var w = slides[0].offsetWidth;
      return w > 0 ? w + gap() : 0;
    }
    function contentWidth() {
      var st = slideStep();
      return st > 0 ? slides.length * st - gap() : 0;
    }
    function maxScroll() { return Math.max(0, contentWidth() - vp.clientWidth); }
    function overflowing() { return maxScroll() > 1; }
    function maxIndexSlides() {
      var st = slideStep();
      return st > 0 ? Math.max(0, Math.ceil(maxScroll() / st)) : 0;
    }
    function looping() { return autoplay && infinite && !isStatic() && overflowing(); }
    function loopWidth() { return slides.length * slideStep(); }
    function loopSteps() { return Math.max(1, slides.length); }
    function currentPos() { return Math.min(Math.max(index * slideStep(), 0), maxScroll()); }

    /* ---- movement -------------------------------------------------------- */
    function setPos(p, animate) {
      pos = p;
      if (animate === false) { list.style.transition = 'none'; void list.offsetWidth; }
      list.style.transform = 'translateX(' + -pos + 'px)';
      if (animate === false) { void list.offsetWidth; list.style.transition = ''; }
    }
    function paint(animate) {
      if (isStatic() || !overflowing()) { list.style.transform = ''; return; }
      if (animate === false) { list.style.transition = 'none'; void list.offsetWidth; }
      list.style.transform = 'translateX(' + -currentPos() + 'px)';
      if (animate === false) { void list.offsetWidth; list.style.transition = ''; }
    }

    function ensureClones() {
      if (cloned) return;
      var frag = document.createDocumentFragment();
      slides.forEach(function (sl) {
        var c = sl.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        /* ids inside a card would otherwise be duplicated across the page */
        [].forEach.call(c.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
        frag.appendChild(c);
      });
      list.appendChild(frag);
      cloned = true;
    }
    function removeClones() {
      if (!cloned) return;
      while (list.children.length > slides.length) list.removeChild(list.lastChild);
      cloned = false;
    }

    /*
      Endless one-direction rotation. The clone set makes the first card follow
      the last; the jump back by exactly one loop width happens BEFORE the move,
      with the transition off, so it is invisible and the move itself is one
      clean transition.
    */
    function rotate(dir) {
      var lw = loopWidth(), st = slideStep();
      if (lw <= 0 || st <= 0) return;
      if (dir > 0 && pos >= lw) setPos(pos - lw, false);
      else if (dir < 0 && pos - st < 0) setPos(pos + lw, false);
      setPos(pos + dir * st, true);
      dotIdx = (dotIdx + dir + loopSteps()) % loopSteps();
      syncNav();
    }

    function go(i, animate) {
      var max = maxIndexSlides();
      index = Math.min(Math.max(i, 0), max);
      paint(animate);
      syncNav();
    }
    function next() { if (looping()) { rotate(1); return; } go(index + 1); }
    function prev() { if (looping()) { rotate(-1); return; } go(index - 1); }

    /* ---- dots, counter, arrows ------------------------------------------- */
    function total() { return looping() ? loopSteps() : maxIndexSlides() + 1; }
    function current() { return looping() ? dotIdx : index; }

    function buildDots() {
      if (!dotsWrap) return;
      /* ⚠️ DO NOT TEAR THE DOTS DOWN IF THE COUNT HAS NOT CHANGED. This used to
         wipe innerHTML and rebuild every time refresh() ran, which RESTARTS the
         CSS width transition on the active pill from scratch — the dots visibly
         flashed and jumped. Combined with refresh() firing on every resize (see
         the resize handler below), scrolling on a phone rebuilt them constantly. */
      var wantTotal = (!overflowing() || isStatic()) ? 0 : (looping() ? loopSteps() : pages());
      if (dotsWrap.children.length === wantTotal && wantTotal > 0) { syncDots(); return; }
      dotsWrap.innerHTML = '';
      if (isStatic() || !overflowing()) return;
      var n = total();
      for (var p = 0; p < n; p++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ehp-dawn-dot';
        b.setAttribute('aria-label', 'Go to slide ' + (p + 1));
        (function (target) {
          b.addEventListener('click', function () {
            if (looping()) { setPos(target * slideStep(), true); dotIdx = target; syncNav(); }
            else go(target);
            restart();
          });
        })(p);
        dotsWrap.appendChild(b);
      }
      syncNav();
    }
    function syncNav() {
      var live = !isStatic() && overflowing();
      root.classList.toggle('ehp-dawn--nonav', !live);
      if (dotsWrap) {
        var kids = dotsWrap.children, a = current();
        for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-active', i === a);
      }
      if (curEl) curEl.textContent = current() + 1;
      if (totEl) totEl.textContent = total();
      var loop = looping();
      if (prevBtn) prevBtn.disabled = !loop && (index <= 0 || !live);
      if (nextBtn) nextBtn.disabled = !loop && (index >= maxIndexSlides() || !live);
    }

    /* ---- autoplay -------------------------------------------------------- */
    function tick() {
      if (looping()) { rotate(autoDir); return; }
      if (autoDir > 0 && index >= maxIndexSlides()) { stop(); return; }
      if (autoDir < 0 && index <= 0) { stop(); return; }
      go(index + autoDir);
    }
    function play() {
      stop();
      if (!autoplay || isStatic() || !overflowing()) return;
      timer = setInterval(tick, speed);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { if (autoplay) play(); }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); next(); restart(); });

    /* hover-pause only where a pointer can actually hover — on touch, mouseenter
       fires on tap and mouseleave often never does, killing autoplay for good */
    if (!window.matchMedia || window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });

    /* ---- swipe / drag ---------------------------------------------------- */
    var dragX = 0, dragging = false, startTx = 0;
    vp.addEventListener('pointerdown', function (e) {
      if (isStatic() || !overflowing()) return;
      dragging = true;
      dragX = e.clientX;
      startTx = looping() ? -pos : -currentPos();
      stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      list.style.transition = 'none';
      list.style.transform = 'translateX(' + (startTx + (e.clientX - dragX)) + 'px)';
    });
    window.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      list.style.transition = '';
      var dx = e.clientX - dragX, threshold = slideStep() * 0.25;
      if (dx <= -threshold) next();
      else if (dx >= threshold) prev();
      else if (looping()) setPos(pos, true);
      else go(index);
      restart();
    });

    /* ---- layout ---------------------------------------------------------- */
    function refresh() {
      if (isStatic()) {
        removeClones();
        list.classList.remove('ehp-dawn-track');
        list.style.transition = '';
        list.style.transform = '';
        pos = 0;
        index = 0;
        stop();
        root.classList.add('ehp-dawn--nonav');
        if (dotsWrap) dotsWrap.innerHTML = '';
        return;
      }
      list.classList.add('ehp-dawn-track');
      if (looping()) {
        /* only reset to the start the FIRST time. A later relayout - the load
           event, a resize - must keep where the track had got to, or the
           carousel jumps back to the first card mid-run. */
        var first = !cloned;
        ensureClones();
        if (first) { dotIdx = 0; pos = 0; }
        buildDots();
        setPos(Math.min(pos, loopWidth()), false);
      } else {
        removeClones();
        if (index > maxIndexSlides()) index = maxIndexSlides();
        buildDots();
        go(index, false);
      }
      syncNav();
      play();
    }

    /* ⚠️ Same trap as the ehp carousels: refresh() snaps back to the start, and
       a phone's address bar hiding on scroll fires resize with an unchanged
       WIDTH. Only react to a real width change. */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(rt);
      rt = setTimeout(refresh, 150);
    });
    window.addEventListener('orientationchange', function () {
      lastW = window.innerWidth;
      clearTimeout(rt);
      rt = setTimeout(refresh, 250);
    });

    /* pause off-screen and in a hidden tab; resume without re-measuring */
    if (window.IntersectionObserver) {
      var vis = true;
      new IntersectionObserver(function (entries) {
        vis = entries[0].isIntersecting;
        if (vis && document.visibilityState !== 'hidden') play();
        else stop();
      }, { rootMargin: '80px' }).observe(root);
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') stop();
        else if (vis) play();
      });
    }
    window.addEventListener('load', refresh);
    refresh();
  }

  function boot(scope) {
    var el = scope && scope.querySelectorAll ? scope : document;
    el.querySelectorAll('[data-ehp-slider]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
  document.addEventListener('DOMContentLoaded', function () { boot(); });
  boot();
})();
